import { TruncatedConeAttributes } from "./TruncatedConeInstanceShader";
// An Instanced version of Three Mesh
export class TruncatedConeInstance {
    constructor(batch, instanceIndex) {
        this.batch = batch;
        this.instanceIndex = instanceIndex;
    }
    isValid() {
        return this.batch && this.instanceIndex !== -1;
    }
    get geometry() {
        return this.batch.geometry;
    }
    get visible() {
        if (this.isValid()) {
            return this.isVisible();
        }
        return false;
    }
    set visible(value) {
        if (this.isValid()) {
            this.setVisible(value);
        }
    }
    isVisible() {
        return this.batch.isVisibleAt(this.instanceIndex);
    }
    setVisible(value) {
        this.batch.setVisibleAt(this.instanceIndex, value);
    }
    // World position
    setPosition(pos) {
        this.batch.setVector3AttributeAt(TruncatedConeAttributes.position, this.instanceIndex, pos);
    }
    // World position
    getPosition(pos) {
        this.batch.getVector3AttributeAt(TruncatedConeAttributes.position, this.instanceIndex, pos);
    }
    // World scale
    setScale(scale) {
        this.batch.setVector3AttributeAt(TruncatedConeAttributes.scale, this.instanceIndex, scale);
    }
    // World scale
    getScale(scale) {
        this.batch.getVector3AttributeAt(TruncatedConeAttributes.scale, this.instanceIndex, scale);
    }
    // World orientation
    setOrientation(q) {
        this.batch.setQuaternionAttributeAt(TruncatedConeAttributes.orientation, this.instanceIndex, q);
    }
    // World orientation
    getOrientation(q) {
        this.batch.getQuaternionAttributeAt(TruncatedConeAttributes.orientation, this.instanceIndex, q);
    }
    setColor(color) {
        this.batch.setColorAttributeAt(TruncatedConeAttributes.color, this.instanceIndex, color);
    }
    getColor(color) {
        this.batch.getColorAttributeAt(TruncatedConeAttributes.color, this.instanceIndex, color);
    }
    setShape(diameterRatio, pointUp) {
        this.batch.setWOfAttributeAt(TruncatedConeAttributes.scale, this.instanceIndex, (1 - diameterRatio) * (pointUp ? 1 : -1));
    }
    destroy() {
        this.batch.deleteInstance(this);
    }
}
